import { useContext } from 'react';
import { DatosSolicitanteContext } from './DatosSolicitanteContext';

const useDatosSolicitante = () => useContext(DatosSolicitanteContext);

export default useDatosSolicitante;